import { z } from "zod";

export const SubscriptionTier = z.enum(["FREE", "STARTUP", "SCALEUP", "ENTERPRISE"]);

export const SubscriptionStatus = z.enum([
  "active",
  "past_due",
  "canceled",
  "incomplete",
  "incomplete_expired",
  "trialing",
  "unpaid",
  "paused"
]);

export const SubscriptionSchema = z.object({
    stripeCustomerId: z.string().trim().min(1).optional(), // Optional initially until created
    stripeSubscriptionId: z.string().trim().optional(),
    tier: SubscriptionTier.default("FREE"),
    status: SubscriptionStatus.default("active"), // Default active (free tier)
    currentPeriodEnd: z.string().datetime().optional(),
    cancelAtPeriodEnd: z.boolean().default(false),
    // Peppol Fees Override (Optional per tenant)
    peppolFees: z.object({
        monthlyFee: z.number().nonnegative().optional(),
        feePerSend: z.number().nonnegative().optional(),
        feePerReceive: z.number().nonnegative().optional(),
    }).optional(),
});

export const FeatureLimits = {
    FREE: {
        maxInvoicesPerMonth: 10,
        aiExtraction: false,
        peppol: false,
        users: 1
    },
    STARTUP: {
        maxInvoicesPerMonth: 100,
        aiExtraction: true,
        peppol: true,
        users: 3
    },
    SCALEUP: {
        maxInvoicesPerMonth: 500,
        aiExtraction: true,
        peppol: true,
        users: 10
    },
    ENTERPRISE: {
        maxInvoicesPerMonth: Infinity,
        aiExtraction: true,
        peppol: true,
        users: Infinity
    }
} as const;

export type Subscription = z.infer<typeof SubscriptionSchema>;
